import React from "react";
import MobileFrame from "./MobileFrame";

interface MemberAppDemoProps {
  formData: any;
}

const MemberAppDemo: React.FC<MemberAppDemoProps> = ({ formData }) => {
  const businessName = formData?.subdomain
    ? `${formData.subdomain.charAt(0).toUpperCase() + formData.subdomain.slice(1)} Fitness`
    : "Your Business";

  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });

  return (
    <MobileFrame
      brandColor={formData?.color || "#3B82F6"}
      showBottomNavigation={true}
    >
      <div className="tw-h-full tw-bg-gray-50 tw-flex tw-flex-col">
        {/* App Header */}
        <div
          className="tw-px-4 tw-py-4 tw-text-white tw-shadow-sm"
          style={{ backgroundColor: formData?.color || "#3B82F6" }}
        >
          <div className="tw-flex tw-items-center tw-justify-between">
            <div>
              <h1 className="tw-text-lg tw-font-semibold">Welcome back!</h1>
              <p className="tw-text-sm tw-opacity-90">Sarah Johnson</p>
            </div>
            <div className="tw-w-10 tw-h-10 tw-bg-white/20 tw-rounded-full tw-flex tw-items-center tw-justify-center">
              <span className="tw-text-sm tw-font-medium">SJ</span>
            </div>
          </div>
        </div>

        {/* Membership Status */}
        <div className="tw-p-4">
          <div className="tw-bg-white tw-p-4 tw-rounded-lg tw-shadow-sm tw-mb-4">
            <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
              <p className="tw-text-sm tw-font-semibold tw-text-gray-700">
                Premium Membership
              </p>
              <span className="tw-text-xs tw-bg-green-100 tw-text-green-800 tw-px-2 tw-py-1 tw-rounded-full">
                Active
              </span>
            </div>
            <p className="tw-text-xs tw-text-gray-500">{businessName}</p>
            <div className="tw-mt-3 tw-flex tw-justify-between tw-text-sm">
              <div>
                <p className="tw-text-gray-500">This Month</p>
                <p className="tw-font-semibold">12 visits</p>
              </div>
              <div>
                <p className="tw-text-gray-500">Streak</p>
                <p className="tw-font-semibold">5 days</p>
              </div>
            </div>
          </div>

          {/* Committed Club */}
          <h3 className="tw-text-sm tw-font-semibold tw-text-gray-700 tw-mb-3">
            Committed Club
          </h3>
          <div className="tw-bg-white tw-p-4 tw-rounded-lg tw-shadow-sm tw-mb-4">
            <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
              <p className="tw-text-sm tw-text-gray-600">{currentMonth}</p>
              <span className="tw-text-sm tw-font-medium tw-text-gray-600">
                8/12
              </span>
            </div>
            <div className="tw-w-full tw-bg-gray-200 tw-rounded-full tw-h-2">
              <div
                className="tw-bg-green-500 tw-h-2 tw-rounded-full tw-transition-all tw-duration-300"
                style={{ width: "66.67%" }}
              ></div>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="tw-px-4 tw-mb-4">
          <h3 className="tw-text-sm tw-font-semibold tw-text-gray-700 tw-mb-3">
            Quick Book
          </h3>
          <div className="tw-space-y-2">
            {formData?.appointmentsEnabled && (
              <button className="tw-w-full tw-bg-white tw-p-3 tw-rounded-lg tw-shadow-sm tw-flex tw-items-center tw-justify-between">
                <div className="tw-flex tw-items-center">
                  <div
                    className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-3"
                    style={{
                      backgroundColor: `${formData?.color || "#3B82F6"}20`,
                    }}
                  >
                    <span className="tw-text-sm">🏋️</span>
                  </div>
                  <div className="tw-text-left">
                    <p className="tw-text-sm tw-font-medium">
                      Personal Training
                    </p>
                    <p className="tw-text-xs tw-text-gray-500">
                      1-on-1 session
                    </p>
                  </div>
                </div>
                <span className="tw-text-gray-400">›</span>
              </button>
            )}

            {formData?.classesEnabled && (
              <button className="tw-w-full tw-bg-white tw-p-3 tw-rounded-lg tw-shadow-sm tw-flex tw-items-center tw-justify-between">
                <div className="tw-flex tw-items-center">
                  <div
                    className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-3"
                    style={{
                      backgroundColor: `${formData?.color || "#3B82F6"}20`,
                    }}
                  >
                    <span className="tw-text-sm">🧘</span>
                  </div>
                  <div className="tw-text-left">
                    <p className="tw-text-sm tw-font-medium">Group Classes</p>
                    <p className="tw-text-xs tw-text-gray-500">
                      Yoga, HIIT & more
                    </p>
                  </div>
                </div>
                <span className="tw-text-gray-400">›</span>
              </button>
            )}

            <button className="tw-w-full tw-bg-white tw-p-3 tw-rounded-lg tw-shadow-sm tw-flex tw-items-center tw-justify-between">
              <div className="tw-flex tw-items-center">
                <div
                  className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-3"
                  style={{
                    backgroundColor: `${formData?.color || "#3B82F6"}20`,
                  }}
                >
                  <span className="tw-text-sm">🎯</span>
                </div>
                <div className="tw-text-left">
                  <p className="tw-text-sm tw-font-medium">Open Gym</p>
                  <p className="tw-text-xs tw-text-gray-500">General access</p>
                </div>
              </div>
              <span className="tw-text-gray-400">›</span>
            </button>
          </div>
        </div>

        {/* Today's Schedule */}
        <div className="tw-px-4 tw-flex-1">
          <h3 className="tw-text-sm tw-font-semibold tw-text-gray-700 tw-mb-3">
            Today&apos;s Schedule
          </h3>
          <div className="tw-space-y-2">
            <div
              className="tw-bg-white tw-p-3 tw-rounded-lg tw-shadow-sm tw-border-l-4"
              style={{ borderLeftColor: formData?.color || "#3B82F6" }}
            >
              <div className="tw-flex tw-items-center tw-justify-between">
                <div>
                  <p className="tw-text-sm tw-font-medium">Morning Yoga</p>
                  <p className="tw-text-xs tw-text-gray-500">
                    8:00 AM - 9:00 AM
                  </p>
                </div>
                <span className="tw-text-xs tw-bg-blue-100 tw-text-blue-800 tw-px-2 tw-py-1 tw-rounded-full">
                  Booked
                </span>
              </div>
            </div>

            <div className="tw-bg-white tw-p-3 tw-rounded-lg tw-shadow-sm">
              <div className="tw-flex tw-items-center tw-justify-between">
                <div>
                  <p className="tw-text-sm tw-font-medium">Personal Training</p>
                  <p className="tw-text-xs tw-text-gray-500">
                    2:30 PM - 3:30 PM
                  </p>
                </div>
                <span className="tw-text-xs tw-bg-green-100 tw-text-green-800 tw-px-2 tw-py-1 tw-rounded-full">
                  Confirmed
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MobileFrame>
  );
};

export default MemberAppDemo;
